import axios from 'axios';
import * as types from './actionTypes';
import { handleError } from '../errors/handleError';
import { getForms } from './FmsActions';
import { checkProjectConfig } from './projectConfigActions';
import { getProjectVersionMenuItems } from './menuItemActions';
import { addAlert } from './alertActions';
import i18n from '../i18n';
import { getPagesforProject } from './contentActions';

export function errorHandler(dispatch, error, type) {
    const errorMessage = handleError(error);

    dispatch({
        type,
        error: errorMessage,
    });
}

export function getProjectVersionModules(projectId) {
    return function (dispatch) {
        dispatch({
            type: types.GET_PROJECT_VERSION_MODULES_PENDING,
        });
        return axios.get(`${window.GENESIS_CMS_API_URL}/v2/projects/${projectId}/modules/latest?sessionId=${localStorage.getItem('SessionId')}&token=${localStorage.getItem('AuthToken')}`)
            .then((response) => {
                dispatch({
                    type: types.GET_PROJECT_VERSION_MODULES_SUCCESS,
                    payload: response.data,
                });
                dispatch({
                    type: types.GET_MODULES_FOR_MENU,
                    payload: response.data.data.filter((obj) => {
                        return obj.enabled;
                    })
                        .map((obj) => {
                            return obj.moduleType;
                        }),
                });
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_PROJECT_VERSION_MODULES_FAILED);
            });
    };
}

export function getModuleByType(projectId, type) {
    return function (dispatch) {
        dispatch({
            type: types.GET_MODULE_PENDING,
        });
        return axios.get(`${window.GENESIS_CMS_API_URL}/v2/projects/${projectId}/modules/latest?sessionId=${localStorage.getItem('SessionId')}&token=${localStorage.getItem('AuthToken')}&type=${type}`)
            .then((response) => {
                dispatch({
                    type: types.GET_MODULE_SUCCESS,
                    payload: response.data.data[0],
                });
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_MODULE_FAILED);
            });
    };
}

export function getModuleByTypeAndForms(projectId, type) {
    return function (dispatch) {
        dispatch({
            type: types.GET_MODULE_PENDING,
        });
        return axios.get(`${window.GENESIS_CMS_API_URL}/v2/projects/${projectId}/modules/latest?sessionId=${localStorage.getItem('SessionId')}&token=${localStorage.getItem('AuthToken')}&type=${type}`)
            .then((response) => {
                return Promise.all([
                    dispatch(getForms(type === 1 ? 0 : type)),
                    dispatch({
                        type: types.GET_MODULE_SUCCESS,
                        payload: response.data.data[0],
                    }),
                ]);
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.GET_MODULE_FAILED);
            });
    };
}

export function updateModule(projectId, moduleType, moduleParamsArray) {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_MODULE_PENDING,
        });
        return axios({
            url: `${window.GENESIS_CMS_API_URL}/v2/projects/${projectId}/modules/latestmultiple?sessionId=${localStorage.getItem('SessionId')}&type=${moduleType}&token=${localStorage.getItem('AuthToken')}`,
            data: moduleParamsArray,
            method: 'PUT',
        })
            .then((response) => {
                return Promise.all([
                    dispatch({
                        type: types.UPDATE_MODULE_SUCCESS,
                        payload: response.data.data,
                    }),
                    dispatch(checkProjectConfig(projectId)),
                    dispatch({
                        type: types.SHOW_NOTIFICATION,
                    }),
                    setTimeout(() => {
                        dispatch({ type: types.HIDE_NOTIFICATION });
                    }, 7000),
                ]);
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.UPDATE_MODULE_FAILED);
            });
    };
}

export function updateModuleParameter(projectId, moduleType, field, value) {
    let endpoint = 'latestsingle';
    if (Array.isArray(value)) {
        endpoint = 'latestsinglelist';
    }
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_MODULE_PARAMETER_PENDING,
        });
        return axios.put(
            `${window.GENESIS_CMS_API_URL}/v2/projects/${projectId}/modules/${endpoint}?sessionId=${localStorage.getItem('SessionId')}&type=${moduleType}&token=${localStorage.getItem('AuthToken')}`,
            {
                parameterName: field,
                parameterValue: value,
            }
        )
            .then((response) => {
                let feedUpdated = () => {
                    return dispatch({ type: 'FEED_NOT_UPDATED' });
                };
                if (field === 'icalFeedUrl') {
                    feedUpdated = () => {
                        return dispatch({
                            type: types.FEED_UPDATED,
                            payload: response.data.data,
                        });
                    };
                }
                let fetchPages = () => {
                    return dispatch({ type: 'NONPAGE_MODULE_UPDATE' });
                };
                if (moduleType === 1) {
                    fetchPages = () => {
                        return function () {
                            dispatch(getPagesforProject(projectId));
                        };
                    };
                }
                return Promise.all([
                    dispatch({
                        type: types.UPDATE_MODULE_PARAMETER_SUCCESS,
                        payload: response.data.data,
                        moduleEnable: field === 'enabled',
                    }),
                    dispatch(feedUpdated()),
                    dispatch(fetchPages()),
                    dispatch(checkProjectConfig(projectId)),
                    dispatch({
                        type: types.SHOW_NOTIFICATION,
                    }),
                    dispatch(getProjectVersionMenuItems(projectId)),
                    setTimeout(() => {
                        dispatch({ type: types.HIDE_NOTIFICATION });
                    }, 7000),
                ]);
            })
            .catch((error) => {
                console.log(`Update Single Failure: ${error.response} ${field}`);
                if (field === 'icalFeedUrl' && error.response && error.response.status !== 404) {
                    dispatch(addAlert({
                        message: i18n.t('calendar.invalid'),
                        view: '/modules/calendar',
                        type: 'error',
                        dismissable: true,
                        id: 'calendar-feed-invalid',
                    }));
                    dispatch({ type: types.CALENDAR_FEED_INVALID });
                }
                errorHandler(dispatch, error.response, types.UPDATE_MODULE_PARAMETER_FAILED);
            });
    };
}

export function bulkUpdateModules(projectId, modules) {
    return function (dispatch) {
        dispatch({
            type: types.UPDATE_MODULES_PENDING,
        });
        return axios({
            url: `${window.GENESIS_CMS_API_URL}/v2/projects/${projectId}/moduleslatest?sessionId=${localStorage.getItem('SessionId')}&token=${localStorage.getItem('AuthToken')}`,
            data: modules,
            method: 'PUT',
        })
            .then((response) => {
                return Promise.all([
                    dispatch({
                        type: types.UPDATE_MODULES_SUCCESS,
                        payload: response.data.data,
                    }),
                    dispatch(checkProjectConfig(projectId)),
                    dispatch({
                        type: types.SHOW_NOTIFICATION,
                    }),
                    setTimeout(() => {
                        dispatch({ type: types.HIDE_NOTIFICATION });
                    }, 7000),
                ]);
            })
            .catch((error) => {
                errorHandler(dispatch, error.response, types.UPDATE_MODULES_FAILED);
            });
    };
}
